

document.addEventListener('DOMContentLoaded', () => {
    initQuantityClamp();
    refreshMaxFromCart();
  });
  document.addEventListener('shopify:section:load', () => {
    initQuantityClamp();
    refreshMaxFromCart();
  });
  document.addEventListener('theme:cart:change', () => {
    refreshMaxFromCart();
    initQuantityClamp();
  });
  document.addEventListener('theme:product:added', refreshMaxFromCart);
  document.addEventListener('theme:cart-drawer:open', () => {
    refreshMaxFromCart();
    initQuantityClamp();
  });
  
  function getWarningWrapper(input) {
    const form = input.closest('product-form') || input.closest('.product-form') || document;
    return form.querySelector('[data-byte-quantity-warning-slot]');
  }
  
  function showLimitWarning(input, max) {
    const warningElement = getWarningWrapper(input);
    if (!warningElement) return;
  
    warningElement.textContent = `Bu üründen en fazla ${max} adet ekleyebilirsiniz.`;
    warningElement.classList.remove('hidden');
  
    clearTimeout(input._byteWarningTimer);
    input._byteWarningTimer = setTimeout(() => {
      warningElement.classList.add('hidden');
    }, 4000);
  }
  
  function hideLimitWarning(input) {
    const warningElement = getWarningWrapper(input);
    if (warningElement) {
      warningElement.classList.add('hidden');
    }
  }
  
  function getCartLineInputs() {
    return Array.from(document.querySelectorAll('.cart__quantity-field[data-product-id]'));
  }
  
  function clampCartLineInput(input) {
    const min = parseInt(input.dataset.min || input.min, 10) || 1;
    const productTotalMax = parseInt(input.dataset.productTotalMax, 10);
    const productId = input.dataset.productId;
  
    if (isNaN(productTotalMax) || !productId) {
      return clampGeneric(input);
    }
  
    const otherLines = getCartLineInputs().filter(
      (other) => other !== input && other.dataset.productId === productId
    );
    const otherLinesTotal = otherLines.reduce((sum, other) => {
      const value = parseInt(other.value, 10);
      return sum + (isNaN(value) ? 0 : value);
    }, 0);
  
    const allowedMaxForThisLine = Math.max(productTotalMax - otherLinesTotal, 0);
  
    let value = parseInt(input.value, 10);
    const rawValue = input.value;
  
    if (isNaN(value) || value < min) {
      value = min;
    }
  
    if (value >= allowedMaxForThisLine) {
        value = allowedMaxForThisLine;
        showLimitWarning(input, productTotalMax);
      } else {
        hideLimitWarning(input);
      }
  
    input.dataset.max = allowedMaxForThisLine;
    input.max = allowedMaxForThisLine;
  
    if (String(value) !== rawValue) {
      input.value = value;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  
  function clampGeneric(input) {
    const min = parseInt(input.dataset.min || input.min, 10) || 1;
    const maxAttr = input.dataset.max || input.max;
    const max = maxAttr ? parseInt(maxAttr, 10) : null;
    let value = parseInt(input.value, 10);
    const rawValue = input.value;
  
    if (isNaN(value) || value < min) {
      value = min;
    }
  
    if (max !== null && !isNaN(max) && value >= max) {
        value = max;
        showLimitWarning(input, max);
      } else {
        hideLimitWarning(input);
      }
  
    if (String(value) !== rawValue) {
      input.value = value;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  
  function initQuantityClamp() {
    const selectors = '[data-quantity-input], .cart__quantity-field, input[name="updates[]"]';
  
    document.querySelectorAll(selectors).forEach((input) => {
      const isCartLine = input.classList.contains('cart__quantity-field') && input.dataset.productId;
      const clamp = () => (isCartLine ? clampCartLineInput(input) : clampGeneric(input));
  
      if (!input.dataset.byteClampBound) {
        input.dataset.byteClampBound = 'true';
  
        input.addEventListener('input', clamp);
        input.addEventListener('change', clamp);
        input.addEventListener('blur', clamp);
  
        const wrapper = input.closest('quantity-input');
        if (wrapper) {
          wrapper.addEventListener('click', () => setTimeout(clamp, 0));
        }
      }
  
      clamp();
    });
  }
  
  async function refreshMaxFromCart() {
    const inputs = document.querySelectorAll('[data-quantity-input][data-product-total-max]');
    if (!inputs.length) return;
  
    let cart;
    try {
      const response = await fetch('/cart.js');
      cart = await response.json();
    } catch (error) {
      console.error('byte-quantity-clamp: cart fetch failed', error);
      return;
    }
  
    inputs.forEach((input) => {
      const variantId = input.dataset.variantId;
      const productTotalMaxRaw = input.dataset.productTotalMax;
  
      if (!productTotalMaxRaw || productTotalMaxRaw === '') return;
  
      const productTotalMax = parseInt(productTotalMaxRaw, 10);
      if (isNaN(productTotalMax)) return;
  
      const currentQtyInCart = cart.items
        .filter((item) => String(item.variant_id) === String(variantId))
        .reduce((sum, item) => sum + item.quantity, 0);
  
      let newMax = productTotalMax - currentQtyInCart;
      if (newMax < 0) newMax = 0;
  
      input.dataset.max = newMax;
      input.max = newMax;
  
      const min = parseInt(input.dataset.min || input.min, 10) || 1;
      let value = parseInt(input.value, 10);
      if (isNaN(value) || value < min) value = min;
  
      if (value > newMax) {
        value = newMax;
        showLimitWarning(input, productTotalMax);
      }
  
      if (String(value) !== input.value) {
        input.value = value;
      }
  
      const plusButton = input.closest('quantity-input')?.querySelector('.quantity__plus');
      if (plusButton) {
        plusButton.disabled = value >= newMax;
      }
    });
  }